<template>
  <el-container class="companies" >
    
    <el-header class="header-style">
    <el-divider content-position="left">企业流水记录</el-divider>
    <el-row>
      <el-col :span="20">
        <el-select
          style="width:270px;"
          v-model="searchArr.acc_discharge_no"
          filterable
          remote
          reserve-keyword
          placeholder="请输入账户明细编号-交易流水号"
          size="mini"
          clearable
          :remote-method="searchRemoteCompanyMethod"
          :loading="searchLoading"
          @change="handleSearchCompanyChange"
        >
          <el-option
            v-for="searchCompany in searchVocherNo"
            :key="searchCompany.id"
            :label="searchCompany.acc_discharge_no"
            :value="searchCompany.acc_discharge_no"
          >
          </el-option>
        </el-select>
        <el-popover placement="bottom-start" v-model="visible" width="450">
          <el-form :model="searchArr" ref="searchForm" label-width="100px">
            <el-form-item label="对方户名" prop="other_acc_name">
              <el-input
                v-model="searchArr.other_acc_name"
                size="mini"
                placeholder="对方户名"></el-input>
            </el-form-item>
            <el-form-item label="交易时间" prop="transfer_time">
              <el-date-picker
                v-model="searchArr.transfer_time"
                type="daterange"
                range-separator="至" size="mini"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                @change="pickerSuccessTimeDateChange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item style="text-align: center">
              <el-button @click="resetForm('searchForm')" size="mini"
                >重置</el-button>
              <el-button
                type="primary"
                @click="submitForm()"
                size="mini"
                >查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
      <el-upload style="float:right" :action="actionHost + '/api/admin/discharge_record/import'" :headers="uploadHeader"
          :show-file-list="false" :on-success="handleImport">
          <el-button type="primary" size="mini">导入</el-button>
        </el-upload>
    </el-row>
  </el-header>

  <el-main class="main-style">
    <el-table
    height="calc(100vh - 276px)"
      :data="dischargeRecords"
      size="medium"
      border
      style="width: 100%;"
      v-cloak
    >
    <el-table-column label="账户明细编号-交易流水号" width="220" fixed>
        <template slot-scope="scope">
          <div v-if="scope.row.acc_discharge_no">
            <el-tooltip :content="scope.row.acc_discharge_no" placement="top">
              <span class="count-style">{{ scope.row.acc_discharge_no }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="账号编号" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.account_num">
            <el-tooltip :content="scope.row.account_num" placement="top">
              <span class="count-style">{{ scope.row.account_num }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="账户名称" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.account_name">
            <el-tooltip :content="scope.row.account_name" placement="top">
              <span class="count-style">{{ scope.row.account_name }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="交易时间" width="140">
        <template slot-scope="scope">
          <div v-if="scope.row.transfer_time">
            <el-tooltip :content="scope.row.transfer_time" placement="top">
              <span class="count-style">
              <!-- {{ scope.row.transfer_time }} -->
              <date-formatter :date-value="scope.row.transfer_time"></date-formatter>
              </span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="借方发生额（支取）" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.creditor">
              <span class="count-style">{{ scope.row.creditor }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="贷方发生额（收入）" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.debtor">
              <span class="count-style">{{ scope.row.debtor }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="余额" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.balance">
            <el-tooltip :content="scope.row.balance" placement="top">
              <span class="count-style">{{ scope.row.balance }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="币种" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.coin_type">
            <el-tooltip :content="scope.row.coin_type" placement="top">
              <span class="count-style">{{ scope.row.coin_type }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="对方户名" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.other_acc_name">
            <el-tooltip :content="scope.row.other_acc_name" placement="top">
              <span class="count-style">{{ scope.row.other_acc_name }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="对方账号" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.other_acc_num">
            <el-tooltip :content="scope.row.other_acc_num" placement="top">
              <span class="count-style">{{ scope.row.other_acc_num }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="凭证种类" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.voucher_type">
              <span class="count-style">{{ scope.row.voucher_type }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="凭证号" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.voucher_no">
            <el-tooltip :content="scope.row.voucher_no" placement="top">
              <span class="count-style">{{ scope.row.voucher_no }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.remark">
            <el-tooltip :content="scope.row.remark" placement="top">
              <span class="count-style">{{ scope.row.remark }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">

        </template>
      </el-table-column> -->
    </el-table>
    </el-main>

    <el-footer class="footer-style">
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </el-footer>

  </el-container>
</template>

<script>
import DateFormatter from "common/DateFormatter";

export default {
  name: 'DischargeRecord',
  components: { DateFormatter },
  data () {
    return {
      searchArr: {
        acc_discharge_no: '',
        other_acc_name: '',
        transfer_time: '',
        transfer_start_time: '',
        transfer_end_time: ''
      },
      searchLoading: false,
      dischargeRecords: [],
      searchVocherNo: [],
      visible: false,
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30 // 每页显示条数
      },
      uploadHeader: { Authorization: localStorage.token },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick: picker => {
              picker.$emit('pick', [new Date(), new Date()])
            }
          },
          {
            text: '昨天',
            onClick: picker => {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [date, date])
            }
          },
          {
            text: '本周',
            onClick: picker => {
              picker.$emit('pick', [this.thisWeek()[0], this.thisWeek()[1]])
            }
          },
          {
            text: '上周',
            onClick: picker => {
              picker.$emit('pick', [this.LastWeek()[0], this.LastWeek()[1]])
            }
          },
          {
            text: '本月',
            onClick: picker => {
              picker.$emit('pick', [this.thisMonth()[0], this.thisMonth()[1]])
            }
          },
          {
            text: '上个月',
            onClick: picker => {
              picker.$emit('pick', [this.LastMonth()[0], this.LastMonth()[1]])
            }
          }
        ]
      }
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      }
    },
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }
      return str
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getDischargeRecords () {
      this.$axios
        .get(
          '/api/admin/discharge_record/index?page=' +
            this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr
        )
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.dischargeRecords = data.data.data.data
            this.pageOption.total = data.data.data.total
            this.pageOption.currentPage = data.data.data.current_page
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
      this.getDischargeRecords()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getDischargeRecords()
    },
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemCompanys(query)
        }, 200)
      } else {
        this.searchVocherNo = []
      }
    },
    searchArrItemCompanys (query) {
      this.$axios.get('/api/admin/searchVocherNo?name=' + query).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.searchVocherNo = data.data.searchVocherNo
        }
      })
    },
    resetForm (formName) {
      this.visible = false
      this.$refs[formName].resetFields()
      this.pageOption.currentPage = 1
      this.getDischargeRecords()
    },
    submitForm () {
      this.visible = false
      this.pageOption.currentPage = 1
      this.getDischargeRecords()
    },
    handleSearchCompanyChange (val) {
      this.pageOption.currentPage = 1
      this.getDischargeRecords()
    },
    handleImport (res, file) {
      if (res.code === 0) {
        this.$message.success(res.msg)
        this.getDischargeRecords()
      }
    },
    pickerSuccessTimeDateChange (val) {
      if (!val) {
        this.searchArr.transfer_start_time = []
        this.searchArr.transfer_end_time = []
      } else {
        this.searchArr.transfer_start_time = val[0]
        this.searchArr.transfer_end_time = val[1]
      }
    },
    LastWeek () {
      const end = new Date()
      const start = new Date()
      const lastWeek = new Date().getDay() // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)) // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek)
      return [start, end]
    },
    thisWeek () {
      var Nowdate = new Date()
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000)

      var M = Number(WeekFirstDay.getMonth()) + 1
      var start =
        WeekFirstDay.getFullYear() + '-' + M + '-' + WeekFirstDay.getDate()

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000)
      var Mon = Number(WeekLastDay.getMonth()) + 1
      var end =
        WeekLastDay.getFullYear() + '-' + Mon + '-' + WeekLastDay.getDate()

      return [start, end]
    },
    thisMonth () {
      const end = new Date()
      const start = new Date()
      // 方法1
      const endDay = new Date().getDate() - 1 // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay)
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end]
    },
    LastMonth () {
      const end = new Date()
      const start = new Date()
      const year = new Date().getFullYear() // 获取年份
      let month = new Date().getMonth() // 获取月份
      month = month === 0 ? 1 : month // 特殊处理:如果为1月 则下方取1月的天数
      const febDays = year % 4 ? 29 : 28 // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31] // 罗列12个月的天数
      start.setDate(1 - days[month - 1]) // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1) // 以此得出,本月1号 - 1天 = 上月最后一天
      return [start, end]
    }
  },
  mounted () {
    this.getDischargeRecords()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

/deep/.el-table {
  overflow: visible;
}
/deep/.el-table__header-wrapper {
  position: sticky;
  top: 0;
  z-index: 10;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.companies >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.companies {
  marginLeft();
  max-height: 100vh;
  .header-style {
    z-index: 2;
    height: 100px !important;
    padding: 0px !important;
  }
  .main-style {
    z-index: 1;
    padding: 0px !important;
    // overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 15px;
    }
  }
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.el-form .el-select {
  width: 100%;
}

.el-dialog .el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/discharge_record/DischargeRecord.vue